import React from 'react';
import { StatusTag } from '@monorepo/ui-kit';
import { USER_STATUS } from '@monorepo/dictionary';
import styles from './index.module.css';

const ContactStatusTag: FC<{ status: number }> = ({ children, status }) => (
  <StatusTag className={styles[USER_STATUS[status]?.toLowerCase()] || ''}>
    {children}
  </StatusTag>
);

export default ContactStatusTag;
